import React, { useContext, useState } from 'react';
import { useToast } from '../../../../../providers/ToastProvider';
import { CompanyContext } from '../../../../../context/CompanyContext';
import { ProductMasterData } from '../../../../../types/product_master_data/productMasterData';
import { KitTemplateInput } from '../../../../../types/kit_template/kitTemplate.input';
import KitTemplateInfoPane from './Panes/KitTemplateInfo';
import { useMutation } from '@apollo/client';
import {
  CreateKitTemplateResponse,
  CreateKitTemplateVariables,
  KitTemplateMutations,
} from '../../../../../graphql/kitTemplate.graphql';
import { KitTemplate } from '../../../../../types/kit_template/kitTemplate';
import { TranslationKey } from '../../../../../types/translation/TranslationKey';
import { t } from '../../../../../types/translation/Translator';
import { ToastType } from '../../../../components/Toast';
import { KitTemplateContext } from '../../../../../context/KitTemplateContext';

interface CreateKitTemplateModalProps {
  open: boolean;
  setOpen: (value: boolean) => void;
  pmd: ProductMasterData;
}

export default function CreateKitTemplateModal({ open, setOpen, pmd }: CreateKitTemplateModalProps) {
  const { currentCompany } = useContext(CompanyContext);
  const { kitTemplates, setKitTemplates } = useContext(KitTemplateContext);
  const { showToast } = useToast();

  const [input, setInput] = useState<KitTemplateInput>(
    new KitTemplateInput({ companyId: currentCompany.id, productMasterDataId: pmd.id }),
  );

  const [create, { loading }] = useMutation<CreateKitTemplateResponse, CreateKitTemplateVariables>(
    KitTemplateMutations.create,
    {
      onCompleted: res => {
        const template = res.createKitTemplate[0];

        kitTemplates.set(template.id, new KitTemplate(template));
        setKitTemplates(new Map(kitTemplates));

        showToast({
          type: ToastType.success,
          title: t(TranslationKey.kitTemplateCreatedSuccessfully).singular.upper,
        });

        setOpen(false);
      },
      onError: res =>
        showToast({
          type: ToastType.error,
          title: res.message,
        }),
    },
  );

  const handleCreate = async () => {
    await create({ variables: { templates: [input.forCreate()] } });
  };

  return (
    <KitTemplateInfoPane
      input={input}
      setInput={setInput}
      open={open}
      setOpen={setOpen}
      loading={loading}
      onCreate={handleCreate}
      onUpdate={async () => {}}
    />
  );
}
